import type { MouseEventHandler, ReactNode } from "react";
import React from "react";
import className from "~/kernel/styling/className";
import type { IconName } from "./Icon";
import Icon from "./Icon";
import { noop } from "~/kernel/functions/noop";

type IconButtonProps = {
  children?: ReactNode;
  "aria-label"?: string;
  onClick?: MouseEventHandler<HTMLButtonElement>;
  icon: IconName;
  disabled?: boolean;
  size?: "default" | "bodyText";
  padding?: "small" | "medium";
};

const IconButton = React.forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      "aria-label": ariaLabel,
      onClick = noop,
      icon,
      children,
      disabled,
      size = "default",
      padding = "small",
    }: IconButtonProps,
    ref,
  ) => {
    return (
      <button
        ref={ref}
        type="button"
        aria-label={ariaLabel}
        onClick={onClick}
        className={className(
          "relative rounded-md hover:bg-slate-100 hover:text-slate-800 disabled:text-slate-300 flex justify-center items-center",
          {
            "px-3 py-2": padding === "small",
            "px-4 py-3": padding === "medium",
          },
        )}
        disabled={disabled}
      >
        <Icon
          name={icon}
          className={className("relative !leading-6", {
            "!text-2xl md:!text-xl": size === "default",
          })}
        />
        {children}
      </button>
    );
  },
);

IconButton.displayName = "IconButton";

export default IconButton;
